export default __webpack_public_path__ + "static/media/BulletedLifeLogoSmall.dabe0125.png";